
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.46 92.29"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M16.88 45.44h53.68L43.72 18.57zm64.09 4.32a3.14 3.14 0 01-.65 1L39.69 91.38a3.12 3.12 0 01-4.4 0L.91 57.01a3.13 3.13 0 010-4.41l40.65-40.62a3.1 3.1 0 014.4 0l34.36 34.37a3.12 3.12 0 01.9 2.22 3.06 3.06 0 01-.25 1.19zm5.75 35.47a9.36 9.36 0 01-7.9 5.68h-1.41a9.36 9.36 0 01-7.94-5.68 9.54 9.54 0 011.53-10l4.69-5.47a3.11 3.11 0 014.75 0l4.69 5.5a9.52 9.52 0 011.59 9.94z"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"43.21","y":"-3.02","width":"6.02","height":"39.26","rx":"2","transform":"rotate(-45 43.764 17.633)"}})])
          )
        }
      }
    